import {
	ROUTE_LOGIN_LINK,
	ROUTE_LOGIN_LINK_NOTIFICATION,
	ROUTE_LOGIN_LINK_SUCCESS,
} from '../../../constants/Routes';
import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { LoginEmailContainer } from './email/LoginEmail.container';
import LinkAccounts from './link-accounts/LinkAccounts.container';
import LinkNotification from './link-notification/LinkNotification.container';
import LinkSuccess from './link-success/LinkSuccess.container';

export default () => (
	<Switch>
		<Route path={ROUTE_LOGIN_LINK_NOTIFICATION} component={LinkNotification} />
		<Route path={ROUTE_LOGIN_LINK} component={LinkAccounts} />
		<Route path={ROUTE_LOGIN_LINK_SUCCESS} component={LinkSuccess} />
		<Route component={LoginEmailContainer} />
	</Switch>
);
